export default __webpack_public_path__ + "static/media/two (1).73944805.png";